import { render, staticRenderFns } from "./BaseUpload.vue?vue&type=template&id=8f682908&scoped=true"
import script from "./BaseUpload.vue?vue&type=script&lang=js"
export * from "./BaseUpload.vue?vue&type=script&lang=js"
import style0 from "./BaseUpload.vue?vue&type=style&index=0&id=8f682908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f682908",
  null
  
)

export default component.exports